import { initialize as initializeMonitoring } from "@aviv-unified-frontend/runtime/monitoring";
import { createErrorMessage } from "@aviv-unified-frontend/internal";

import { BRAND_CONFIGURATION } from "../../configs/brands";
import { ENVIRONMENT, VERSION } from "../constants/environment";

let hasBeenInitialized = false;

export const initialize = () => {
  if (hasBeenInitialized)
    throw new Error(
      createErrorMessage({
        cause: "The initialize has already been initialized",
        solution: "Make sure the initialize method is called once",
      }),
    );

  initializeMonitoring({
    environment: ENVIRONMENT,
    version: VERSION,
    brand: BRAND_CONFIGURATION.id,
  });
  overrideConsoleMethods();
  hasBeenInitialized = true;
};

/**
 * Overrides the console methods to ignore specific messages or methods on live environments.
 * This is useful to avoid displaying warnings from internal libraries.
 */
export const overrideConsoleMethods = () => {
  if (ENVIRONMENT !== "live") {
    return;
  }

  const originalWarn = console.warn;

  console.warn = (...args) => {
    const message = args.join(" ");

    if (message.includes("aviv")) {
      return;
    }

    originalWarn.apply(console, args);
  };

  console.log = () => {
    return;
  };
};
